import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=062fec44&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062fec44')) {
      api.createRecord('062fec44', component.options)
    } else {
      api.reload('062fec44', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=062fec44&", function () {
      api.rerender('062fec44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bbVom5RKRK9u/JS/offershelp.vue"
export default component.exports